import React, { useContext, useEffect, useMemo } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { scheduleCleningSchema } from '../../../util/validationSchema'
import { SpinnerContext } from '../../../context/spinnerContext'
import { createManualPropertySchedule } from '../../../redux/slices/propertySlice'
import { getDefaultTime, getISOToUTCDateFromTimestamp, getTimeStamp } from '../../../helper/function'
import { errorToast, successToast } from '../../../util/Toast/toast'
import CommonDateTimePicker from '../../../component/commonDateTimePicker'

const AddEditSchedule = ({ propertyId, setIsRefresh, toggleScheduleModal, cleaning_on, setUpcomingRefresh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, setValue, control, trigger } = useForm({
    resolver: yupResolver(scheduleCleningSchema),
    defaultValues: {
      booking_date_time: getISOToUTCDateFromTimestamp(getDefaultTime(11)), // 11:00 AM
      next_checkin_time: getISOToUTCDateFromTimestamp(getDefaultTime(16)) // 4:00 PM
    }
  })

  const isRequiredField = useMemo(() => (cleaning_on === 'Cleaning on checkout' ? 'booking_date_time' : 'next_checkin_time'), [cleaning_on])

  useEffect(() => {
    setValue('properties_id', propertyId)
    setValue('is_automated', false)
    setValue('cleaning_on', cleaning_on)
  }, [propertyId])

  const onSubmit = (data) => {
    delete data.cleaning_on
    const payload = {
      ...data,
      booking_date_time: data?.booking_date_time ? getTimeStamp(data?.booking_date_time) : '',
      next_checkin_time: data?.next_checkin_time ? getTimeStamp(data?.next_checkin_time) : ''
    }
    setIsRefresh(false)
    changeLoader(true)
    if (propertyId) {
      dispatch(createManualPropertySchedule(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggleScheduleModal()
          setIsRefresh(true)
          setUpcomingRefresh && setUpcomingRefresh(true)
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Check-Out
                {isRequiredField === 'booking_date_time' && <span className="text-danger"> *</span>}
              </label>

              <div className="date_picker_main_div">
                <CommonDateTimePicker
                  name="booking_date_time"
                  control={control}
                  placeholder="yyyy-MM-ddTHH:mm A"
                  onDateChange={() => {
                    trigger('booking_date_time')
                  }}
                  disablePast={false}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Next Check-In
                {isRequiredField === 'next_checkin_time' && <span className="text-danger"> *</span>}
              </label>
              <div className="date_picker_main_div">
                <CommonDateTimePicker
                  name="next_checkin_time"
                  control={control}
                  placeholder="yyyy-MM-ddTHH:mm A"
                  onDateChange={() => {
                    trigger('next_checkin_time')
                  }}
                  disablePast={false}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleScheduleModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Save`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddEditSchedule
